<script> 
  export default {
    name: 'UiInput',
    props: {
      value: {
        type: String,
        default: ''
      },
      isInvalid: {
        type: Boolean,
        default: false
      }
    },
  }
</script>

<template>
  <input
    :value="value"
    @input="$emit('input', $event.target.value)"
    @blur="$emit('blur', $event.target.value)"
    class="UiInput" 
    :class="{ 'is-invalid': isInvalid }"
  />
</template>

<style lang="scss" scoped>
  .UiInput {
    border: var(--input-border);
    height: var(--input-height);
    padding: 0 var(--input-padding-x);
    border-radius: var(--input-radius);
    width: 100%;
    min-width: 0px;

    &:focus {
      border-color: var(--input-focus-border-color);
      box-shadow: var(--input-focus-shadow);
    }
    &:disabled {
      cursor: not-allowed;
      background-color: var(--input-disabled-bg);
    }
    &.is-invalid {
      border-color: red;
    }
    &::-webkit-calendar-picker-indicator {
      opacity: .4;
    }
  }
</style>